import { TextureBoxIcon } from './TextureBoxIcon';

/**
 * author: Michael Irigoyen
 * id 7B46F16A-AF86-4A7A-B3AB-1D2297831078
 * name texture-box
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/texture-box.svg
 * tags
 * - Math 
 */
export const SurfaceAreaIcon = TextureBoxIcon;
export default SurfaceAreaIcon